import React from 'react'
import Field from '../Common/Field'
import TimePicker from '../Common/TimePicker'

export default class Time extends Field {
  renderInput() {
    const {
      formikForm,
      formikField: {
        value
      },
      isRequired,
      config: {
        label, name, placeholder, locale, valueFormat,
        inputFormat, displayFormat, readOnly, disabled
      }
    } = this.props

    return (
      <div className="field__input field__input--time">
        <TimePicker
          label={label}
          className="field__time"
          name={name}
          value={value}
          valueFormat={valueFormat}
          inputFormat={inputFormat}
          displayFormat={displayFormat}
          placeholder={placeholder}
          locale={locale}
          aria-required={!!isRequired}
          readOnly={readOnly}
          disabled={disabled}
          timeIntervals={30}
          onChange={(value) => {
            formikForm.setFieldValue(name, value, true)
          }}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
        />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/Time.js